import { DocumentItemAlerts } from 'bank-documents/src/types/DocumentItemAlerts'

import { ChoiceOption } from '../../commons'
import { HistoryEntity } from '../historyAudit'
import { LicenseWebPageRequest } from './LicenseWebPageRequest'

type LicenseWebPageAddress = {
  city: string
  postalCode: string
  state: string
  street: string
}

type LicenseWebPageTaxRates = {
  cityTax: string
  countyTax: string
  MJRetailTax: string
  specialTax: string
  stateTax: string
}

type LicenseWebPageRelationship = {
  id: number
  name: string
}

export type LicenseWebPageInvoiceSubmittalItem = {
  amount: number
  id: number
  notes: string
  number: string
  updatedAt: string
}

export type LicenseWebPageInvoiceSubmittal = {
  items: LicenseWebPageInvoiceSubmittalItem[]
  totalCount: number
}

export type LicenseWebPageDocumentItem = {
  alerts: DocumentItemAlerts
  expirationDate: string
  frequency: string
  id: number
  internal: boolean
  name: string
}

export type LicenseWebPageDocuments = {
  filters: {
    alerts: {
      items: [
        {
          label: string
          value: string
        }
      ]
      value: string
    }
    frequency: {
      items: [
        {
          label: string
          value: string
        }
      ]
      value: string
    }
    isInternal: {
      items: [
        {
          label: string
          value: string
        }
      ]
      value: string
    }
  }
  items: LicenseWebPageDocumentItem[]
  size: number
  sortFields: string[]
  total: number
}

export type LicenseWebPageHistory = {
  items: HistoryEntity[]
  totalCount: number
}

export type LicenseWebPageResponse = {
  alertsOptions: ChoiceOption[]
  frequencyOptions: ChoiceOption[]
  internalOptions: ChoiceOption[]
  id: number
  active: boolean
  createdAt: string
  issueDate: string
  showNullificationDate?: string
  name: string
  number: string
  phone: string
  posType: string
  showPosTypeOther: string
  sidebar: string[]
  subType: string
  type: string
  updatedAt: string
  address: LicenseWebPageAddress
  documents: LicenseWebPageDocuments
  history: LicenseWebPageHistory
  invoiceSubmittal: LicenseWebPageInvoiceSubmittal
  relationship: LicenseWebPageRelationship
  taxRates: LicenseWebPageTaxRates
  APIConnection: string
  form: LicenseWebPageRequest
  showCRBConnectionStatus: string
  showCRBConnectionMark: 'success' | 'warning' | 'danger'
  internalNotes: string
}
